import { Box, Typography, Chip } from "@mui/material";
import heart_card from "../../../../../assets/heart_card.png";
import spade_card from "../../../../../assets/spade_card.png";
import { CardFormValues } from "../../../../../../types/Card";

interface CardDetailBannerProps {
  primary_thumbnail: any;
  suit?: string;
  title: string;
  card: CardFormValues;
}

export const CardDetailBanner = ({
  primary_thumbnail,
  suit,
  title,
  card,
}: CardDetailBannerProps) => {
  const getCardImage = (
    image?: string | File | null,
    suit?: string
  ): string => {
    if (typeof image === "string" && image.trim() !== "") return image;
    if (image instanceof Blob) return URL.createObjectURL(image);
    if (suit?.toLowerCase() === "heart") return heart_card;
    if (suit?.toLowerCase() === "spade") return spade_card;
    return "https://images.unsplash.com/photo-1575936123452-b67c3203c357?q=80&w=4740&auto=format&fit=crop";
  };

  return (
    <Box position="relative" borderRadius={3} overflow="hidden">
      {/* Image Background */}
      <Box
        component="img"
        src={getCardImage(primary_thumbnail, suit)}
        alt={title}
        sx={{
          width: "100%",
          height: { xs: 260, md: 400 },
          objectFit: "cover",
        }}
      />

      {/* Overlay Gradient */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          px: 2,
          py: 1.5,
          background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
          zIndex: 1,
        }}
      >
        <Typography
          fontFamily="Lexend"
          fontWeight={600}
          fontSize={{ xs: "1rem", md: "1.25rem" }}
          color="#fff"
          noWrap
        >
          {card.banner_title}
        </Typography>
      </Box>

      {/* Top-left Status Tags */}
      {suit === "Clover" && (
        <Box
          position="absolute"
          top={16}
          left={16}
          display="flex"
          gap={1}
          zIndex={2}
        >
          <Chip
            label="Stage Mode"
            size="small"
            sx={{
              backgroundColor: "#6366F1",
              color: "#fff",
              fontWeight: 500,
              fontSize: 12,
            }}
          />
        </Box>
      )}
    </Box>
  );
};
